/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const HotDocsIcon = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="357.67px"
        height="118.04px"
        viewBox="0 0 357.67 118.04"
        xmlSpace="preserve"
        className={className}
    >
        <path
            fill={color}
            d="M171.15,38.21h-0.35v40.51h11.99c5.15,0,8.88-0.36,11.57-2.13c3.4-2.21,5.35-6.61,5.35-12.05v-12.2
    	c0-5.46-1.9-9.75-5.34-12.05c-2.9-1.92-6.78-2.08-11.57-2.08H171.15z M182.19,46.58c5.66,0,7.76,2.07,7.76,7.66v8.39
    	c0,5.55-2.18,7.71-7.76,7.71c0,0-1.54,0-1.75,0c0-0.23,0-23.54,0-23.76C180.64,46.58,182.19,46.58,182.19,46.58z"
        />
        <path
            fill={color}
            d="M209.69,40.98L209.69,40.98c-3.43,3.5-3.69,7.8-3.69,13.97v7.03c0,6.16,0.26,10.47,3.69,13.97
    	c2.46,2.49,6.04,3.81,10.35,3.81c4.34,0,7.94-1.32,10.41-3.81c3.43-3.5,3.69-7.8,3.69-13.97v-7.03c0-6.17-0.26-10.47-3.69-13.97
    	c-2.47-2.49-6.06-3.81-10.41-3.81C215.73,37.17,212.15,38.49,209.69,40.98z M215.75,63.44V53.42c0-5.48,0.4-7.88,4.28-7.88
    	c3.88,0,4.28,2.4,4.28,7.88v10.02c0,5.48-0.4,7.88-4.28,7.88C216.15,71.32,215.75,68.92,215.75,63.44z"
        />
        <path
            fill={color}
            d="M243.91,40.98L243.91,40.98c-3.43,3.5-3.69,7.8-3.69,13.97v7.03c0,6.16,0.26,10.47,3.69,13.97
    	c2.46,2.49,6.05,3.81,10.35,3.81c8.3,0,13.88-4.98,13.88-12.38v-3.01h-9.59v0.94c0,4.34-1.2,6.03-4.29,6.03
    	c-3.88,0-4.28-2.4-4.28-7.88V53.42c0-5.46,0.17-7.88,4.28-7.88c2.94,0,4.18,1.59,4.29,5.49l0.01,0.34h9.58v-2.74
    	c0-6.53-5.97-11.46-13.88-11.46C249.95,37.17,246.38,38.49,243.91,40.98z"
        />
        <path
            fill={color}
            d="M272.98,49.07c0,3.8,1.51,6.98,4.38,9.2c2.08,1.6,4.72,2.65,7.77,3.86c0,0,2.3,0.92,2.3,0.92
    	c2.9,1.2,4.25,2.7,4.25,4.74c0,2.26-1.94,3.85-4.73,3.85c-3.01,0-5.2-1.55-7.54-5.34l-0.2-0.32l-7.53,5.25l0.17,0.28
    	c3.44,5.46,8.45,8.23,14.87,8.23c8.52,0,14.26-5.06,14.26-12.6c0-3.89-1.56-7.25-4.38-9.48c-1.87-1.47-4.38-2.48-7.28-3.64l-2.9-1.2
    	c-3.25-1.42-4.65-2.79-4.65-4.58c0-1.98,1.66-3.3,4.12-3.3c2.63,0,4.92,1.41,7,4.32l0.2,0.28l6.96-4.91l-0.18-0.28
    	c-2.96-4.77-7.5-7.19-13.49-7.19C278.25,37.17,272.98,41.84,272.98,49.07z"
        />
        <path
            fill={color}
            d="M58.52,27.19H69.1v17.06c3.96-5.78,7.84-6.92,12.56-6.92c2.97,0,5.4,1.14,6.92,3.27
    	c1.67,2.29,1.75,4.79,1.75,7.84c0,0.23,0,0.53,0,0.76v29.53H79.75V53.47c0-4.57-0.46-6.32-3.58-6.32c-1.98,0-4.34,1.29-7.08,4.03
    	v27.55H58.52V27.19z"
        />
        <path
            fill={color}
            d="M161.81,70.36c0.46,0,0.91,0,1.12,0v8.35c-1.27,0.15-2.79,0.15-4.09,0.15c-10.43,0-13.85-4.68-13.85-14.14
    	V46.58h-5.93v-8.34h5.93V27.19h10.58v11.05h7.38v8.34h-7.38v14.59C155.57,67.84,155.52,70.36,161.81,70.36z"
        />
        <path
            fill={color}
            d="M127.5,70.54h0.01l0.01,8.15h-2.63l-8.75-6.88h-3.96c-11.95,0-17.73-5.55-17.73-16.99
    	c0-11.43,5.79-16.99,17.73-16.99h6.85c11.95,0,17.73,5.55,17.73,16.99C136.77,63.12,133.72,68.31,127.5,70.54z M128.32,54.82
    	c0-5.31-4.11-6.69-12.71-6.69c-8.6,0-12.71,1.39-12.71,6.69c0,5.26,3.96,6.48,12.46,6.5l7.99,6.25l-0.02-6.88h-0.01
    	C126.7,59.89,128.32,58.18,128.32,54.82z"
        />
        <g>
            <g>
                <path
                    fill={color}
                    d="M129.11,87.59c0.49-0.5,1.2-0.78,2.09-0.78s1.61,0.28,2.1,0.78c0.69,0.71,0.74,1.6,0.74,2.88v1.47
    			c0,1.28-0.06,2.17-0.74,2.88c-0.49,0.5-1.21,0.78-2.1,0.78s-1.6-0.27-2.09-0.78c-0.69-0.71-0.74-1.6-0.74-2.88v-1.47
    			C128.36,89.19,128.42,88.3,129.11,87.59z M132.15,90.14c0-1.17-0.09-1.72-0.96-1.72c-0.87,0-0.96,0.55-0.96,1.72v2.1
    			c0,1.17,0.09,1.72,0.96,1.72c0.87,0,0.96-0.55,0.96-1.72V90.14z"
                />
                <path
                    fill={color}
                    d="M138.55,92.25c0,1.21,0.18,1.72,1.14,1.72c0.97,0,1.14-0.53,1.14-1.72v-5.22h1.85v5.64
    			c0,1.96-0.96,2.91-2.99,2.91c-2.02,0-2.99-0.95-2.99-2.91v-5.64h1.85V92.25z"
                />
                <path
                    fill={color}
                    d="M147.09,88.64h-2.12v-1.61h6.07v1.61h-2.11v6.74h-1.85V88.64z"
                />
                <path
                    fill={color}
                    d="M154.32,92.89c0.48,0.79,0.95,1.15,1.62,1.15c0.64,0,1.05-0.38,1.05-0.88c0-0.46-0.29-0.8-0.93-1.07
    			c-0.82-0.34-1.54-0.58-2.06-0.99c-0.58-0.46-0.88-1.1-0.88-1.87c0-1.47,1.04-2.42,2.7-2.42c1.21,0,2.14,0.5,2.73,1.48l-1.32,0.95
    			c-0.44-0.63-0.94-0.94-1.51-0.94c-0.57,0-0.92,0.32-0.92,0.76c0,0.42,0.33,0.73,1,1.03c0.84,0.37,1.59,0.6,2.09,1
    			c0.56,0.45,0.88,1.12,0.88,1.93c0,1.52-1.14,2.57-2.88,2.57c-1.31,0-2.32-0.57-3.01-1.69L154.32,92.89z"
                />
            </g>
            <path
                fill={color}
                d="M163.74,87.03c1.13,0,1.97,0.05,2.57,0.38c0.75,0.43,1.16,1.2,1.16,2.23c0,1.03-0.41,1.82-1.16,2.24
    		c-0.59,0.33-1.44,0.39-2.57,0.39h-0.25v3.11h-1.85v-8.35H163.74z M163.49,90.85H164c1.17,0,1.6-0.25,1.6-1.2
    		c0-0.96-0.43-1.21-1.6-1.21h-0.51V90.85z"
            />
            <path
                fill={color}
                d="M170.63,87.59c0.49-0.5,1.2-0.78,2.09-0.78c0.89,0,1.61,0.28,2.1,0.78c0.68,0.71,0.74,1.6,0.74,2.88v1.47
    		c0,1.28-0.06,2.17-0.74,2.88c-0.49,0.5-1.21,0.78-2.1,0.78c-0.89,0-1.6-0.27-2.09-0.78c-0.69-0.71-0.74-1.6-0.74-2.88v-1.47
    		C169.89,89.19,169.94,88.3,170.63,87.59z M173.68,90.14c0-1.17-0.09-1.72-0.96-1.72c-0.87,0-0.96,0.55-0.96,1.72v2.1
    		c0,1.17,0.09,1.72,0.96,1.72c0.87,0,0.96-0.55,0.96-1.72V90.14z"
            />
            <path
                fill={color}
                d="M178.74,87.03h1.85v8.35h-1.85V87.03z M183.19,87.03h1.97l-2.49,3.86l2.91,4.49h-2.18l-2.72-4.35L183.19,87.03
    		z"
            />
            <path
                fill={color}
                d="M188.23,87.03h5.63v1.61h-3.78v1.5h2.58v1.61h-2.58v2.02h4.02v1.61h-5.87V87.03z"
            />
            <path
                fill={color}
                d="M197.08,87.03h1.78l2.67,5.06l-0.03-5.06h1.61v8.35h-1.52l-2.93-5.64l0.03,5.64h-1.61V87.03z"
            />
            <path fill={color} d="M207.02,93.63h1.79v1.74h-1.79V93.63z" />
            <g>
                <g>
                    <path
                        fill={color}
                        d="M212.67,87.59c0.49-0.5,1.2-0.78,2.09-0.78c0.89,0,1.61,0.28,2.1,0.78c0.68,0.71,0.74,1.6,0.74,2.88v1.47
    				c0,1.28-0.06,2.17-0.74,2.88c-0.49,0.5-1.21,0.78-2.1,0.78c-0.89,0-1.6-0.27-2.09-0.78c-0.68-0.71-0.74-1.6-0.74-2.88v-1.47
    				C211.93,89.19,211.98,88.3,212.67,87.59z M215.71,90.14c0-1.17-0.09-1.72-0.96-1.72c-0.86,0-0.95,0.55-0.95,1.72v2.1
    				c0,1.17,0.09,1.72,0.95,1.72c0.87,0,0.96-0.55,0.96-1.72V90.14z"
                    />
                    <path
                        fill={color}
                        d="M222.11,92.25c0,1.21,0.19,1.72,1.14,1.72c0.97,0,1.14-0.53,1.14-1.72v-5.22h1.85v5.64
    				c0,1.96-0.96,2.91-2.99,2.91c-2.02,0-2.99-0.95-2.99-2.91v-5.64h1.85V92.25z"
                    />
                    <path
                        fill={color}
                        d="M230.65,88.64h-2.11v-1.61h6.07v1.61h-2.11v6.74h-1.85V88.64z"
                    />
                    <path
                        fill={color}
                        d="M237.89,92.89c0.48,0.79,0.95,1.15,1.62,1.15c0.64,0,1.05-0.38,1.05-0.88c0-0.46-0.3-0.8-0.92-1.07
    				c-0.83-0.34-1.54-0.58-2.07-0.99c-0.58-0.46-0.88-1.1-0.88-1.87c0-1.47,1.04-2.42,2.71-2.42c1.21,0,2.13,0.5,2.73,1.48
    				l-1.33,0.95c-0.44-0.63-0.93-0.94-1.5-0.94c-0.57,0-0.93,0.32-0.93,0.76c0,0.42,0.33,0.73,1,1.03c0.84,0.37,1.59,0.6,2.09,1
    				c0.56,0.45,0.88,1.12,0.88,1.93c0,1.52-1.14,2.57-2.87,2.57c-1.31,0-2.32-0.57-3.01-1.69L237.89,92.89z"
                    />
                </g>
                <path
                    fill={color}
                    d="M246.43,88.64h-2.11v-1.61h6.08v1.61h-2.11v6.74h-1.85V88.64z"
                />
                <path
                    fill={color}
                    d="M256.43,93.71h-2.51l-0.43,1.67h-1.79l2.4-8.35h2.18l2.4,8.35h-1.79L256.43,93.71z M256.07,92.28l-0.89-3.76
    			l-0.9,3.76H256.07z"
                />
                <path
                    fill={color}
                    d="M261.2,87.03h1.78l2.68,5.06l-0.04-5.06h1.61v8.35h-1.51l-2.93-5.64l0.03,5.64h-1.61V87.03z"
                />
                <path
                    fill={color}
                    d="M272.86,87.03c1.04,0,1.79,0.05,2.35,0.42c0.67,0.46,1.08,1.33,1.08,2.46v2.55c0,1.15-0.4,2.03-1.08,2.47
    			c-0.55,0.36-1.31,0.44-2.35,0.44h-2.41v-8.35H272.86z M272.73,93.77c1.2,0,1.68-0.48,1.68-1.69v-1.76c0-1.21-0.47-1.68-1.68-1.68
    			h-0.43v5.13H272.73z"
                />
                <path
                    fill={color}
                    d="M278.69,94.59h0.95v-6.83h-0.95v-0.73h3.76v0.73h-0.96v6.83h0.96v0.79h-3.76V94.59z"
                />
                <path
                    fill={color}
                    d="M285.1,87.03h1.78l2.67,5.06l-0.03-5.06h1.61v8.35h-1.52l-2.94-5.64l0.04,5.64h-1.61V87.03z"
                />
                <path
                    fill={color}
                    d="M295.15,87.59c0.47-0.5,1.2-0.78,2.09-0.78c1.69,0,2.75,0.96,2.83,2.57h-1.88c-0.04-0.63-0.37-0.96-0.95-0.96
    			c-0.91,0-0.96,0.58-0.96,1.72v2.1c0,1.13,0.05,1.72,0.96,1.72c0.67,0,0.95-0.4,0.95-1.27v-0.32h-0.96v-1.43h2.85v4.52h-0.83
    			l-0.26-0.68c-0.49,0.55-1.04,0.79-1.8,0.79c-0.84,0-1.57-0.29-2.03-0.78c-0.69-0.71-0.74-1.59-0.74-2.88v-1.47
    			C294.4,89.19,294.46,88.3,295.15,87.59z"
                />
            </g>
            <path fill={color} d="M303.36,93.63h1.79v1.74h-1.79V93.63z" />
        </g>
        <g>
            <g>
                <g>
                    <path
                        fill={color}
                        d="M13,58.56c0.67,19.63,10.3,33.5,18.45,40.94c8.32,7.72,15.17,9.02,14.15,10.01
    				c-0.21,0.39-8.21,0.02-17.24-7.79C19.5,94.27,9.6,79.38,9.76,58.91c-0.22-20.44,8.52-35.7,15.73-44.54
    				C32.94,5.32,38.86,2.68,38.74,2.63C41.07,1.92,12.44,17.92,13,58.56z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M7.93,71.79c1.48,0.8,2.9,2.09,4.63,4.59c1.63,2.41,3.69,5.87,3.95,9.08c0.28,3.23-1.63,4.4-3.44,4.49
    				C11.17,90.02,9.42,89,7.7,87.32c-3.52-3.37-8.11-10.59-7.67-14.79C0.55,68.58,5.01,70.39,7.93,71.79z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M14.76,91.18c1.6-0.11,3.28,0.32,5.6,1.81c2.19,1.46,5.06,3.82,6.28,6.9c1.23,3.09-0.06,5.24-1.62,6.33
    				c-1.65,1.11-3.51,1.08-5.58,0.42c-4.19-1.35-10.69-5.41-11.66-9.69C6.97,92.78,11.67,91.56,14.76,91.18z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M26.28,80.86c0.23,2.23,0.29,4.29-0.2,6.4c-0.47,1.97-1.48,4.08-3.31,3.05c-1.83-1.02-3.17-4.66-3.66-7.53
    				c-0.53-3.02-0.36-5.24,0.06-7.22c0.9-3.9,3.07-9.06,4.6-7.69C25.21,69.41,25.65,76.39,26.28,80.86z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M26.2,106.67c0.59-1.32,1.47-2.25,3.06-2.62c1.53-0.33,3.75-0.14,5.55,1.77c1.81,1.89,2.17,4.44,2.02,6.27
    				c-0.18,1.91-0.91,3.03-2,3.85c-2.22,1.54-6.29,3.33-8.6,0.92C23.99,114.31,25.09,109.34,26.2,106.67z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M34.58,92.67c0.5,1.89,0.8,3.67,0.58,5.57c-0.23,1.78-0.98,3.74-2.86,3.08c-1.89-0.65-3.6-3.61-4.44-6.01
    				c-0.89-2.53-1.02-4.46-0.87-6.22c0.35-3.48,1.69-8.22,3.38-7.27C32.01,82.94,33.42,88.89,34.58,92.67z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M7.54,53.07c0.86,1.56,1.59,3.44,2.3,6.34c0.64,2.77,1.39,6.51,0.76,8.91c-0.63,2.42-2.44,2.01-3.83,0.91
    				c-1.46-1.19-2.49-3.03-3.29-5.33c-1.68-4.61-2.88-12.95-1.52-15.72C3.28,45.66,5.75,50.13,7.54,53.07z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M19.83,65.92c-0.23,2.04-0.58,3.88-1.39,5.61c-0.77,1.61-2.02,3.16-3.32,1.75c-1.31-1.4-1.69-4.94-1.56-7.59
    				c0.14-2.79,0.69-4.71,1.41-6.35c1.46-3.22,4.17-7.31,5.18-5.7C21.06,55.39,20.16,61.79,19.83,65.92z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M11.32,36.34c0.3,1.78,0.46,3.77,0.39,6.6c-0.09,2.69-0.28,6.22-1.28,7.92c-1.01,1.72-2.35,0.51-3.17-1.1
    				c-0.87-1.71-1.23-3.77-1.31-6.12c-0.23-4.72,0.87-12.59,2.48-14.38C9.91,27.7,10.61,32.92,11.32,36.34z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M17.83,51.48c-0.6,1.48-1.25,2.74-2.24,3.66c-0.93,0.85-2.2,1.39-2.82-0.32c-0.62-1.71-0.1-4.58,0.57-6.57
    				c0.71-2.09,1.5-3.33,2.34-4.28c1.7-1.82,4.42-3.92,4.84-2.16C20.86,43.66,18.96,48.43,17.83,51.48z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M16.78,24.86c-0.08,1.61-0.29,3.35-0.8,5.71c-0.5,2.24-1.21,5.11-2.23,6.19c-1.03,1.09-1.79-0.36-2.12-1.97
    				c-0.33-1.71-0.23-3.53,0.11-5.52c0.65-4,2.8-10.35,4.22-11.41C17.26,16.99,16.83,21.73,16.78,24.86z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M19.82,37.82c-0.84,1.18-1.68,2.1-2.73,2.54c-0.98,0.4-2.2,0.32-2.32-1.63c-0.12-1.95,1.01-4.5,2.04-6.14
    				c1.09-1.72,2.03-2.57,2.95-3.12c1.83-1.02,4.54-1.91,4.49,0.02C24.12,31.48,21.46,35.36,19.82,37.82z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M23.66,26.04c-0.83,0.67-1.62,1.1-2.43,1c-0.76-0.11-1.56-0.76-1.17-2.55c0.38-1.78,1.74-3.53,2.8-4.53
    				c1.12-1.05,1.94-1.41,2.67-1.51c1.43-0.11,3.43,0.2,2.98,1.96C27.98,22.2,25.33,24.6,23.66,26.04z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M29.64,16.24c-0.81,0.5-1.54,0.79-2.21,0.6c-0.63-0.19-1.22-0.88-0.63-2.43c0.58-1.55,1.99-2.94,3.04-3.71
    				c1.11-0.81,1.86-1.04,2.5-1.04c1.24,0.07,2.9,0.58,2.26,2.11C33.88,13.31,31.27,15.15,29.64,16.24z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M37.17,6.2c-0.99,0.79-1.91,1.41-2.85,1.72c-0.88,0.28-1.8,0.25-1.4-1.01c0.4-1.27,1.94-2.94,3.2-4.02
    				c1.33-1.13,2.33-1.71,3.25-2.09c1.79-0.7,4.34-1.34,3.74-0.09C42.41,1.98,39.14,4.55,37.17,6.2z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M23.6,14.4c-0.44,1.48-0.99,3-1.86,4.95c-0.84,1.83-1.95,4.11-2.87,4.61c-0.93,0.5-1.12-1.15-0.95-2.76
    				c0.18-1.7,0.69-3.31,1.4-4.98c1.39-3.35,4.44-8.4,5.59-8.81C25.93,7.14,24.38,11.5,23.6,14.4z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M31.17,7.12c-0.75,1.33-1.54,2.66-2.65,4.2c-1.05,1.45-2.38,3.16-3.08,3.13c-0.71-0.02-0.33-1.83,0.29-3.38
    				c0.65-1.64,1.48-3.03,2.46-4.39c1.92-2.71,5.53-6.56,6.3-6.43C35.09,0.48,32.56,4.46,31.17,7.12z"
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        fill={color}
                        d="M344.67,58.56c-0.67,19.63-10.3,33.5-18.45,40.94c-8.32,7.72-15.17,9.02-14.15,10.01
    				c0.21,0.39,8.21,0.02,17.25-7.79c8.85-7.45,18.75-22.33,18.6-42.81c0.21-20.44-8.52-35.7-15.73-44.54
    				c-7.46-9.05-13.38-11.69-13.25-11.74C316.6,1.92,345.23,17.92,344.67,58.56z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M349.73,71.79c-1.48,0.8-2.9,2.09-4.64,4.59c-1.62,2.41-3.69,5.87-3.95,9.08c-0.27,3.23,1.63,4.4,3.44,4.49
    				c1.91,0.07,3.66-0.95,5.38-2.62c3.52-3.37,8.11-10.59,7.67-14.79C357.11,68.58,352.66,70.39,349.73,71.79z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M342.9,91.18c-1.6-0.11-3.28,0.32-5.6,1.81c-2.19,1.46-5.06,3.82-6.28,6.9c-1.23,3.09,0.06,5.24,1.62,6.33
    				c1.65,1.11,3.51,1.08,5.58,0.42c4.19-1.35,10.69-5.41,11.66-9.69C350.7,92.78,346,91.56,342.9,91.18z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M331.39,80.86c-0.23,2.23-0.29,4.29,0.2,6.4c0.47,1.97,1.48,4.08,3.31,3.05c1.83-1.02,3.17-4.66,3.66-7.53
    				c0.53-3.02,0.36-5.24-0.06-7.22c-0.9-3.9-3.07-9.06-4.6-7.69C332.46,69.41,332.02,76.39,331.39,80.86z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M331.47,106.67c-0.59-1.32-1.47-2.25-3.06-2.62c-1.53-0.33-3.75-0.14-5.55,1.77
    				c-1.81,1.89-2.17,4.44-2.02,6.27c0.18,1.91,0.92,3.03,2,3.85c2.21,1.54,6.28,3.33,8.6,0.92
    				C333.67,114.31,332.58,109.34,331.47,106.67z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M323.08,92.67c-0.5,1.89-0.8,3.67-0.58,5.57c0.23,1.78,0.98,3.74,2.86,3.08c1.89-0.65,3.6-3.61,4.44-6.01
    				c0.89-2.53,1.02-4.46,0.88-6.22c-0.35-3.48-1.69-8.22-3.38-7.27C325.66,82.94,324.24,88.89,323.08,92.67z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M350.13,53.07c-0.86,1.56-1.59,3.44-2.3,6.34c-0.64,2.77-1.39,6.51-0.76,8.91c0.63,2.42,2.44,2.01,3.83,0.91
    				c1.46-1.19,2.49-3.03,3.28-5.33c1.68-4.61,2.88-12.95,1.52-15.72C354.39,45.66,351.91,50.13,350.13,53.07z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M337.84,65.92c0.23,2.04,0.58,3.88,1.39,5.61c0.77,1.61,2.02,3.16,3.32,1.75c1.31-1.4,1.69-4.94,1.56-7.59
    				c-0.14-2.79-0.69-4.71-1.41-6.35c-1.46-3.22-4.17-7.31-5.18-5.7C336.61,55.39,337.51,61.79,337.84,65.92z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M346.35,36.34c-0.3,1.78-0.46,3.77-0.39,6.6c0.09,2.69,0.28,6.22,1.28,7.92c1.01,1.72,2.34,0.51,3.17-1.1
    				c0.86-1.71,1.23-3.77,1.31-6.12c0.23-4.72-0.87-12.59-2.48-14.38C347.76,27.7,347.06,32.92,346.35,36.34z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M339.83,51.48c0.6,1.48,1.25,2.74,2.23,3.66c0.93,0.85,2.2,1.39,2.82-0.32c0.62-1.71,0.09-4.58-0.57-6.57
    				c-0.71-2.09-1.5-3.33-2.34-4.28c-1.7-1.82-4.42-3.92-4.84-2.16C336.81,43.66,338.71,48.43,339.83,51.48z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M340.88,24.86c0.08,1.61,0.29,3.35,0.8,5.71c0.5,2.24,1.22,5.11,2.23,6.19c1.03,1.09,1.79-0.36,2.12-1.97
    				c0.33-1.71,0.23-3.53-0.11-5.52c-0.65-4-2.8-10.35-4.22-11.41C340.41,16.99,340.83,21.73,340.88,24.86z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M337.84,37.82c0.84,1.18,1.68,2.1,2.73,2.54c0.98,0.4,2.2,0.32,2.32-1.63c0.12-1.95-1.01-4.5-2.04-6.14
    				c-1.09-1.72-2.03-2.57-2.95-3.12c-1.83-1.02-4.54-1.91-4.49,0.02C333.55,31.48,336.2,35.36,337.84,37.82z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M334.01,26.04c0.84,0.67,1.62,1.1,2.43,1c0.76-0.11,1.56-0.76,1.17-2.55c-0.38-1.78-1.74-3.53-2.8-4.53
    				c-1.12-1.05-1.94-1.41-2.66-1.51c-1.43-0.11-3.43,0.2-2.98,1.96C329.69,22.2,332.34,24.6,334.01,26.04z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M328.03,16.24c0.81,0.5,1.54,0.79,2.21,0.6c0.63-0.19,1.22-0.88,0.63-2.43c-0.58-1.55-1.99-2.94-3.04-3.71
    				c-1.11-0.81-1.86-1.04-2.5-1.04c-1.24,0.07-2.9,0.58-2.26,2.11C323.79,13.31,326.4,15.15,328.03,16.24z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M320.5,6.2c1,0.79,1.91,1.41,2.85,1.72c0.87,0.28,1.8,0.25,1.4-1.01c-0.4-1.27-1.94-2.94-3.2-4.02
    				c-1.33-1.13-2.33-1.71-3.24-2.09c-1.79-0.7-4.34-1.34-3.75-0.09C315.25,1.98,318.53,4.55,320.5,6.2z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M334.06,14.4c0.44,1.48,0.98,3,1.85,4.95c0.84,1.83,1.94,4.11,2.87,4.61c0.93,0.5,1.12-1.15,0.95-2.76
    				c-0.18-1.7-0.69-3.31-1.4-4.98c-1.39-3.35-4.44-8.4-5.59-8.81C331.73,7.14,333.29,11.5,334.06,14.4z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M326.5,7.12c0.74,1.33,1.54,2.66,2.65,4.2c1.05,1.45,2.38,3.16,3.08,3.13c0.71-0.02,0.32-1.83-0.29-3.38
    				c-0.65-1.64-1.48-3.03-2.46-4.39c-1.92-2.71-5.54-6.56-6.3-6.43C322.57,0.48,325.11,4.46,326.5,7.12z"
                    />
                </g>
            </g>
        </g>
        <g>
            <path
                fill={color}
                d="M57.81,8.47c0-1.65,0.29-3.23,1.41-4.47c1.01-1.12,2.53-1.54,4.05-1.54c1.65,0,3.17,0.4,4.25,1.56
    		c0.9,0.97,1.41,2.4,1.41,4.99v3.92c0,2.27-0.37,3.72-1.39,4.82c-1.34,1.45-3.28,1.61-4.31,1.61c-1.58,0-4.18-0.57-4.99-3.3
    		c-0.35-1.14-0.42-2.55-0.42-3.26V8.47z M61.42,13.52c0,1.69,0.33,2.9,1.91,2.9c1.91,0,1.91-1.78,1.91-2.9V7.92
    		c0-1.12,0-2.49-1.87-2.49c-1.96,0-1.96,1.85-1.96,2.49V13.52z"
            />
            <path
                fill={color}
                d="M73.32,2.77h10.74v2.95h-7.17v3.48h4.77v2.99h-4.77v6.73h-3.56V2.77z"
            />
            <path
                fill={color}
                d="M87.64,2.77h10.74v2.95h-7.17v3.48h4.77v2.99h-4.77v6.73h-3.56V2.77z"
            />
            <path
                fill={color}
                d="M100.82,18.92v-1.43h1.89V4.18h-1.89V2.77h7.37v1.41h-1.91v13.27h1.91v1.47H100.82z"
            />
            <path
                fill={color}
                d="M111.49,8.2c0-3.7,1.98-5.79,5.74-5.79c0.97,0,2.42,0.2,3.54,1.08c1.45,1.14,1.63,3.12,1.67,4.42h-3.54
    		c-0.02-0.79-0.07-2.55-1.83-2.55c-0.44,0-0.99,0.18-1.34,0.51c-0.57,0.53-0.59,1.32-0.59,1.76v6.14c0,0.88,0,2.57,1.96,2.57
    		c1.45,0,1.89-1.19,1.89-2.93h3.56c-0.02,1.17-0.04,1.3-0.15,1.98c-0.13,0.64-0.35,1.8-1.69,2.88c-1.14,0.92-2.82,1.08-3.52,1.08
    		c-1.87,0-3.17-0.44-4.18-1.43c-0.66-0.64-1.52-1.56-1.52-4.86V8.2z"
            />
            <path
                fill={color}
                d="M125.81,18.92v-1.43h1.89V4.18h-1.89V2.77h7.37v1.41h-1.91v13.27h1.91v1.47H125.81z"
            />
            <path
                fill={color}
                d="M144.1,2.77l4.66,16.15h-3.45l-0.81-3.21h-4.95l-0.84,3.21h-3.45l4.55-16.15H144.1z M142.01,5.65h-0.09
    		l-1.76,7.3h3.63L142.01,5.65z"
            />
            <path fill={color} d="M151.88,2.77h3.61V15.9h7.11v3.01h-10.71V2.77z" />
            <path
                fill={color}
                d="M180.81,7.1c-0.51-0.97-1.54-1.8-2.79-1.8c-1.85,0-1.89,1.39-1.89,1.56c0,1.14,1.06,1.61,2.05,1.96l2.05,0.75
    		c0.97,0.35,2.11,1.01,2.75,1.89c0.2,0.26,0.9,1.32,0.9,2.84c0,0.73,0,2.88-2.29,4.27c-0.95,0.57-2.29,0.81-3.1,0.81
    		c-2.84,0-4.51-0.68-5.96-3.28l2.75-1.83c0.59,1.36,1.67,2.2,3.06,2.2c0.77,0,2.16-0.35,2.16-1.83c0-1.21-0.66-1.47-3.08-2.42
    		c-2.44-0.95-4.55-2.02-4.55-5.21c0-2.66,1.94-4.58,5.26-4.58c2.38,0,4.05,0.97,5.37,2.9L180.81,7.1z"
            />
            <path
                fill={color}
                d="M187.72,2.77h10.85v2.95h-7.33v3.43h5.04v2.95h-4.99v3.81h7.79v3.01h-11.35V2.77z"
            />
            <path fill={color} d="M203.01,2.77h3.61V15.9h7.11v3.01h-10.71V2.77z" />
            <path
                fill={color}
                d="M217.6,2.77h10.85v2.95h-7.33v3.43h5.04v2.95h-4.99v3.81h7.79v3.01H217.6V2.77z"
            />
            <path
                fill={color}
                d="M233.04,8.2c0-3.7,1.98-5.79,5.74-5.79c0.97,0,2.42,0.2,3.54,1.08c1.45,1.14,1.63,3.12,1.67,4.42h-3.54
    		c-0.02-0.79-0.07-2.55-1.83-2.55c-0.44,0-0.99,0.18-1.34,0.51c-0.57,0.53-0.59,1.32-0.59,1.76v6.14c0,0.88,0,2.57,1.96,2.57
    		c1.45,0,1.89-1.19,1.89-2.93h3.56c-0.02,1.17-0.04,1.3-0.15,1.98c-0.13,0.64-0.35,1.8-1.69,2.88c-1.14,0.92-2.82,1.08-3.52,1.08
    		c-1.87,0-3.17-0.44-4.18-1.43c-0.66-0.64-1.52-1.56-1.52-4.86V8.2z"
            />
            <path fill={color} d="M259.42,2.77v2.95h-4.03v13.2h-3.7V5.72h-4.11V2.77H259.42z" />
            <path
                fill={color}
                d="M261.68,18.92v-1.43h1.89V4.18h-1.89V2.77h7.37v1.41h-1.91v13.27h1.91v1.47H261.68z"
            />
            <path
                fill={color}
                d="M272.31,8.47c0-1.65,0.29-3.23,1.41-4.47c1.01-1.12,2.53-1.54,4.05-1.54c1.65,0,3.17,0.4,4.25,1.56
    		c0.9,0.97,1.41,2.4,1.41,4.99v3.92c0,2.27-0.37,3.72-1.38,4.82c-1.34,1.45-3.28,1.61-4.31,1.61c-1.58,0-4.18-0.57-4.99-3.3
    		c-0.35-1.14-0.42-2.55-0.42-3.26V8.47z M275.92,13.52c0,1.69,0.33,2.9,1.91,2.9c1.91,0,1.91-1.78,1.91-2.9V7.92
    		c0-1.12,0-2.49-1.87-2.49c-1.96,0-1.96,1.85-1.96,2.49V13.52z"
            />
            <path
                fill={color}
                d="M288.2,2.77h3.39l4.16,7.55c0.18,0.33,0.4,0.77,0.55,1.1c0.06,0.13,0.29,0.73,0.35,0.84h0.11l-0.09-1.63
    		c-0.07-1.1-0.07-1.23-0.07-1.85V2.77h3.26v16.15h-2.9l-4.29-7.83c-0.35-0.64-0.37-0.7-1.21-2.66h-0.11
    		c0.02,0.46,0.11,2.51,0.11,2.93v7.57h-3.26V2.77z"
            />
        </g>
        <g>
            <path
                fill={color}
                d="M58.93,104.39v-2.26c0.84-2.33,2.4-4.08,5.11-6.17c1.97-1.49,2.9-2.5,2.9-4.01c0-1.44-0.79-2.35-2.18-2.35
    		c-1.27,0-2.18,0.77-3.24,2.95l-2.83-1.34c1.32-2.93,3.07-4.39,6.22-4.39c3.84,0,5.62,2.09,5.62,5.06c0,2.74-1.3,4.06-4.1,6.05
    		c-2.09,1.49-3.14,2.47-3.65,3.72h7.97v2.74H58.93z"
            />
            <path
                fill={color}
                d="M78.76,104.68c-3.96,0-6.55-2.9-6.55-8.16v-1.54c0-5.26,2.59-8.16,6.55-8.16c3.96,0,6.55,2.9,6.55,8.16v1.54
    		C85.31,101.77,82.72,104.68,78.76,104.68z M81.42,94.55c0-2.98-0.82-4.82-2.66-4.82c-1.82,0-2.64,1.85-2.64,4.8v2.42
    		c0,2.98,0.82,4.82,2.64,4.82c1.85,0,2.66-1.82,2.66-4.8V94.55z"
            />
            <path
                fill={color}
                d="M86.85,104.39v-2.26c0.84-2.33,2.4-4.08,5.11-6.17c1.97-1.49,2.9-2.5,2.9-4.01c0-1.44-0.79-2.35-2.18-2.35
    		c-1.27,0-2.18,0.77-3.24,2.95l-2.83-1.34c1.32-2.93,3.07-4.39,6.22-4.39c3.84,0,5.62,2.09,5.62,5.06c0,2.74-1.3,4.06-4.1,6.05
    		c-2.09,1.49-3.14,2.47-3.65,3.72h7.97v2.74H86.85z"
            />
            <path
                fill={color}
                d="M106.67,104.68c-3.96,0-6.55-2.9-6.55-8.16v-1.54c0-5.26,2.59-8.16,6.55-8.16c3.96,0,6.55,2.9,6.55,8.16v1.54
    		C113.22,101.77,110.63,104.68,106.67,104.68z M109.33,94.55c0-2.98-0.82-4.82-2.66-4.82c-1.82,0-2.64,1.85-2.64,4.8v2.42
    		c0,2.98,0.82,4.82,2.64,4.82c1.85,0,2.66-1.82,2.66-4.8V94.55z"
            />
        </g>
    </svg>
);

HotDocsIcon.propTypes = propTypes;
HotDocsIcon.defaultProps = defaultProps;

export default HotDocsIcon;
